import PresupuestoService from 'src/modules/presupuesto/presupuestoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PRESUPUESTO_VIEW';

const presupuestoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: presupuestoViewActions.FIND_STARTED,
      });

      const record = await PresupuestoService.find(id);

      dispatch({
        type: presupuestoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: presupuestoViewActions.FIND_ERROR,
      });

      getHistory().push('/presupuesto');
    }
  },
};

export default presupuestoViewActions;
